module.exports = __webpack_public_path__ + "img/help9.765acc3d.png";